import { EditJaneView } from 'components/JaneModal/views/EditJaneView';
import { JaneDetailsView } from 'components/JaneModal/views/JaneDetailsView';
import { UseGQLQueryConfig } from 'hooks/useGQLQuery/useGQLQuery.types';
import i18next from 'i18next';
import { DateTime } from 'luxon';
import { transformSeniorityDate } from 'pages/TeamMemberPage/TeamMemberPage.constants';
import { createApolloCache, createApolloClient } from 'providers/ApolloProvider';
import { QUERY_janeModalJaneDetails } from 'queries';
import { ModalRoutingService } from 'services';
import { JaneModalJaneDetailsQuery } from 'types/graphql';

export const JaneModalHeaderMap = {
  JaneDetailsView: 'Team Member Profile',
  EditJaneView: 'Edit Profile',
};

export const JaneModalComponentMap = {
  EditJaneView,
  JaneDetailsView,
};

export const janeModalRoutingService = new ModalRoutingService(
  'janeModal',
  'JaneDetailsView',
  JaneModalComponentMap,
  {
    janeModalJaneId: 'number',
  },
  [],
);
const fetchJaneApolloClient = createApolloClient({ cache: createApolloCache() });
export const fetchJaneConfig = (
  janeId?: string,
): UseGQLQueryConfig<
  JaneModalJaneDetailsQuery,
  JaneModalJaneDetailsQuery,
  { id: string | undefined }
> => ({
  key: 'FETCH_JANE_DETAIL_BY_ID_QUERY',
  query: QUERY_janeModalJaneDetails,
  client: fetchJaneApolloClient,
  variables: {
    id: janeId,
  },
  responseTransformer: (data) => {
    if (!data?.fetchJane?.rankingSeniorityDate) {
      return data;
    }

    return {
      ...data,
      fetchJane: {
        ...data.fetchJane,
        rankingSeniorityDate: { ...transformSeniorityDate(data.fetchJane.rankingSeniorityDate) },
      },
    };
  },
});
export const getLanguageString = (language: string): string => {
  switch (language) {
    case 'en':
      return `${i18next.t('team_member:ENGLISH')}`;
    case 'fr':
      return `${i18next.t('team_member:FRENCH')}`;
    default:
      return '-';
  }
};
export const humanReadableDate = (date: string, timeZone?: Nullable<string>) => {
  const dateTimeZone = timeZone || undefined;
  const month = DateTime.fromISO(date).setZone(dateTimeZone).toFormat('LLL').toUpperCase();
  return `${i18next.t(month)} ${DateTime.fromISO(date)
    .setZone(dateTimeZone)
    .toFormat('d, yyyy')} ${i18next.t('common:AT')} ${DateTime.fromISO(date)
    .setZone(dateTimeZone)
    .toFormat('hh:mm a')}`;
};
export const employeeReadableDate = (date: string, timeZone?: Nullable<string>) => {
  const dateTimeZone = timeZone || undefined;
  const month = DateTime.fromISO(date).setZone(dateTimeZone).toFormat('LLL').toUpperCase();
  return `${i18next.t(month)} ${DateTime.fromISO(date).setZone(dateTimeZone).toFormat('d, yyyy')}`;
};
